module.exports = __webpack_public_path__ + "img/logo-xs.b4b2173f.png";